import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Project } from '@src/app/models/project';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProjectvisibilitytoggleService {

  constructor(private http:HttpClient) { }

  updateProject(project:Project){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.patch<any>(environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/project/'+project.projectId,project,httpOptions)
  }
}
